import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/react";
import {
  ButtonClickTrackingPlugin,
  enableButtonClickTracking,
} from "@snowplow/browser-plugin-button-click-tracking";
import {
  enableLinkClickTracking,
  LinkClickTrackingPlugin,
} from "@snowplow/browser-plugin-link-click-tracking";
import {
  enableActivityTracking,
  newTracker,
  trackPageView,
} from "@snowplow/browser-tracker";

import { isSnowplowEnabled } from "@hooks/use-analytics-tracking";
import { strToBool } from "@lib/app.helpers";
import { OrganizationTrackPlugin } from "@lib/tracking.plugins";

export const SP_MAIN_TRACKER = "sp1";
export const SP_GROWTHBOOK_TRACKER = "sp-growthbook";

export const isSentryEnabled = () => strToBool(import.meta.env.SENTRY_ENABLED);

export const initObservability = () => {
  if (isSentryEnabled()) {
    console.info("============");
    console.info("Enabling Sentry");
    Sentry.init({
      dsn: import.meta.env.SENTRY_DSN,
      environment: import.meta.env.APP_ENV,
      release: import.meta.env.SENTRY_RELEASE,
      sendDefaultPii: true,
    });
  }

  if (isSnowplowEnabled) {
    console.info("============");
    console.info("Enabling Snowplow");

    newTracker(SP_MAIN_TRACKER, import.meta.env.SNOWPLOW_COLLECTOR_URL, {
      appId: "ceStudentExperience",
      discoverRootDomain: true,
      cookieSameSite: "Lax",
      contexts: {
        performanceTiming: true,
      },
      plugins: [
        OrganizationTrackPlugin.init(),
        ButtonClickTrackingPlugin(),
        LinkClickTrackingPlugin(),
      ],
    });
    newTracker(
      SP_GROWTHBOOK_TRACKER,
      import.meta.env.SNOWPLOW_GROWTHBOOK_COLLECTOR_URL,
      {
        appId: "ceStudentExperience",
        discoverRootDomain: true,
        cookieSameSite: "Lax",
        plugins: [OrganizationTrackPlugin.init()],
      },
    );

    enableActivityTracking(
      {
        minimumVisitLength: 30,
        heartbeatDelay: 10,
      },
      [SP_MAIN_TRACKER],
    );
    enableButtonClickTracking(undefined, [SP_MAIN_TRACKER]);
    enableLinkClickTracking({ pseudoClicks: true }, [SP_MAIN_TRACKER]);

    trackPageView(undefined, [SP_MAIN_TRACKER]);
  }

  if (strToBool(import.meta.env.DATADOG_ENABLED)) {
    console.info("============");
    console.info("Enabling DataDog");
    const datadogConfig = [
      "APPLICATION_ID",
      "CLIENT_TOKEN",
      "SERVICE",
      "ENV",
      "VERSION",
      "SESSION_SAMPLE_RATE",
      "SESSION_REPLAY_RATE",
    ].reduce((acc, varName) => {
      acc[varName] = import.meta.env[`DATADOG_${varName}`];
      return acc;
    }, {});

    datadogRum.init({
      applicationId: datadogConfig.APPLICATION_ID,
      clientToken: datadogConfig.CLIENT_TOKEN,
      service: datadogConfig.SERVICE,
      env: datadogConfig.ENV,
      version: datadogConfig.VERSION,
      sessionSampleRate: Number(datadogConfig.SESSION_SAMPLE_RATE),
      sessionReplaySampleRate: Number(datadogConfig.SESSION_REPLAY_RATE),
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    });
  }
};
